import { defineMessages } from '@transcend-io/internationalization';

export const requestHistoryPreviewMessages = defineMessages(
  'privacy-center.containers.RequestHistoryPreview.requestHistoryPreview',
  {
    preview: {
      defaultMessage:
        '{count} {count, plural, one {Active Request} other {Active Requests}}',
    },
  },
);
